import { useState } from 'react';
import useHashRouteToggle from '../pdf/useHashRouteToggle';

const EMPTY_VIEWER_INFO = { title: null, pdfLink: null, mediaType: null };

/**
 * State for the full-screen PDF/video viewer. The open state is tied to the URL
 * hash so the browser back button closes the viewer instead of leaving the page.
 */
const useTechLibraryViewer = () => {
  const [info, setInfo] = useState(EMPTY_VIEWER_INFO);
  const [isOpen, toggleOpen] = useHashRouteToggle('#item');

  const openViewer = (nextInfo) => {
    toggleOpen(true);
    setInfo(nextInfo);
  };

  const closeViewer = () => {
    setInfo(EMPTY_VIEWER_INFO);
    toggleOpen(false);
  };

  return { isOpen, info, openViewer, closeViewer };
};

export default useTechLibraryViewer;
